<template>
  <v-container class="mt-0 pt-0">
    <!-----------CREATING NEW CATEGORY FORM--------------------------------------->
    <v-form @submit.prevent="createCategory" ref="createForm" lazy-validation>
      <v-dialog v-model="dialogCreate" width="50%" persistent>
        <v-card>
          <v-card-title class="headline footer" primary-title>
            {{ dialogText }}
          </v-card-title>
          <br />
          <v-card-text>
            <v-flex xs12 sm6 offset-sm3 mt-3>
              <v-layout column>
                <v-flex>
                  <v-text-field
                    label="Name"
                    v-model="newCategory.titleNew"
                    type="text"
                    :rules="[rules.required]"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex>
                  <v-flex>
                    <v-text-field
                      label="SKU code"
                      v-model="newCategory.SKU_Code"
                      type="text"
                      :rules="[rules.required]"
                    >
                    </v-text-field>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-expansion-panels v-if="languages.length > 0">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Translation</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <v-row v-for="(item, i) in languages" :key="i">
                    <v-col>
                      <v-text-field
                        color="accent"
                        :label="item.name"
                        v-model="newCategory[item.code]"
                        type="text"
                        outlined
                        dense
                        clearable
                        :rules="[rules.required]"
                        @wheel="$event.target.blur()"
                      >
                      </v-text-field
                    ></v-col>
                  </v-row> </v-expansion-panel-content></v-expansion-panel
            ></v-expansion-panels>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined color="error" @click="closeCreateDialog">
              Close
            </v-btn>
            <v-btn color="success" outlined @click="createCategory">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <!----------------------------------------------------------------------------->
    <v-form @submit.prevent="AddSkus" ref="createForm" lazy-validation>
      <v-dialog v-model="openSKUCODE" width="50%" persistent>
        <v-card>
          <v-card-title class="headline footer" primary-title>
            Add the SKU code for the current categories
          </v-card-title>
          <br />
          <v-card-text>
            <v-row
              v-for="(item, i) in WithoutSKUs"
              :key="i"
              class="container_sku_code"
            >
              <v-col>
                <h4><b> Name :</b> {{ item.name }}</h4>
                <h4><b> Path :</b> {{ item.path }}</h4>
              </v-col>
              <v-col>
                <v-text-field
                  label="SKU Code"
                  v-model="item.SKU_Code"
                  type="text"
                  :rules="[rules.required]"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined color="error" @click="closeAddSKU"> Close </v-btn>
            <v-btn color="success" outlined @click="AddSkus"> Save </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <!-----------MAIN CONTAINER---------------------------------------------------->
    <v-card v-if="!failed">
      <v-card-title class="footer basic--text headline py-2">
        <v-row>
          <v-col cols="3">Wholesales Category tree </v-col>

          <v-col>
            <v-btn @click="openCreateTopCategory" color="accent" outlined>
              NEW TOP CATEGORY
              <v-icon right>mdi-plus-circle</v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <v-btn @click="AddSKUCode" color="accent" outlined>
              ADD SKU CODES
              <v-icon right>mdi-plus-circle</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <!-----------SEARCH BAR------------------------------------------------------->
      <v-sheet class="px-2 pb-2 footer">
        <v-text-field
          v-model="search"
          label="Search Category"
          flat
          solo-inverted
          hide-details
          dense
          clearable
          clear-icon="mdi-close-circle-outline"
        ></v-text-field>
      </v-sheet>

      <!----------------------------------------------------------------------------->
      <v-row class="pa-4" justify="space-between">
        <!-----------LEFT TAB (CATEGORY TREE)------------------------------------------>

        <v-col cols="3" class="px-0">
          <v-row>
            <v-col class="ml-1 pb-0">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    @click="toggleTreeview"
                    size="30"
                    >{{
                      expanded
                        ? "mdi-unfold-less-horizontal"
                        : "mdi-unfold-more-horizontal"
                    }}</v-icon
                  >
                </template>
                <span>Expand/Collapse all</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-treeview
                :active.sync="active"
                :items="items"
                return-object
                activatable
                color="accent"
                transition
                :search="search"
                :filter="filter"
                @update:active="setCategoryDetails"
                dense
                :open-all="expanded"
                ref="mytreeview"
                :expand-icon="'mdi-chevron-down'"
              >
                <template slot="append" slot-scope="{ item }">
                  <v-btn
                    class="ml-6"
                    id="addBtn"
                    @click="openCreateSubCategory(item)"
                    fab
                    color="accent"
                    small
                  >
                    <v-icon dark> mdi-plus </v-icon>
                  </v-btn>
                </template>
              </v-treeview>
            </v-col>
          </v-row>
        </v-col>
        <v-divider vertical></v-divider>
        <!-------------------------------------------------------------------------------------->

        <!-----------RIGHT TAB (CONFIGURATION)-------------------------------------------------->
        <v-col class="d-flex" cols="9">
          <v-scroll-y-transition mode="out-in">
            <div style="width: 100%" v-if="active.length > 0">
              <h4>Size configuration for category : {{ active[0].name }}</h4>
              <v-alert
                class="my-4"
                text
                dense
                color="blue"
                icon="mdi-information-outline"
                border="left"
              >
                If your selected field type is "Select", then write down select
                values dividing them by commas.
              </v-alert>
              <v-layout v-for="(item, i) in selectedConfiguration" :key="i">
                <v-sheet color="accent_light" class="mb-4 pt-4" width="100%">
                  <v-form
                    @sumbit.prevent="pushConfig"
                    ref="configForm"
                    lazy-validation
                    v-model="valid"
                  >
                    <v-row align-content="center">
                      <v-col cols="2">
                        <v-text-field
                          label="Title"
                          v-model="item.title"
                          type="text"
                          :rules="[rules.required]"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-select
                          label="Field type"
                          v-model="item.type"
                          :items="fieldTypes"
                          item-text="text"
                          item-value="value"
                          type="text"
                          :rules="[rules.required]"
                          outlined
                          dense
                        >
                        </v-select>
                      </v-col>
                      <v-col cols="3" v-if="item.type == 'select'">
                        <v-combobox
                          multiple
                          v-model="item.values"
                          label="Enter values for select"
                          chips
                          deletable-chips
                          @keyup.tab="updateTags"
                          @paste="updateTags"
                          :delimiters="[',']"
                          :rules="[rules.requiredMultiple]"
                          dense
                          small-chips
                          outlined
                        >
                        </v-combobox>
                      </v-col>
                      <v-col cols="1" class="mt-1">
                        <v-icon
                          class="ml-4"
                          size="30"
                          color="error"
                          cursor="pointer"
                          @click="removeField(i)"
                          >mdi-close-thick</v-icon
                        >
                      </v-col>
                    </v-row>
                  </v-form>
                </v-sheet>
              </v-layout>
              <v-row>
                <v-col cols="4">
                  <v-btn color="success" @click="addField" outlined>
                    <v-icon left> mdi-plus-circle </v-icon>
                    Add field</v-btn
                  >
                </v-col>
              </v-row>

              <v-divider class="pt-4"></v-divider>
              <v-row>
                <v-col cols="4">
                  <v-btn color="success" @click="pushConfig" :disabled="!valid">
                    <v-icon left> mdi-import </v-icon>
                    Save configuration</v-btn
                  >
                </v-col>
              </v-row>
            </div>
          </v-scroll-y-transition>
        </v-col>
      </v-row>
    </v-card>
    <!----------------------------------------------------------------------------->

    <!-----------STATUS DIALOG----------------------------------------------------->
    <v-dialog v-model="statusDialog" width="unset">
      <status-info
        :responseMessage="responseMessage"
        :filename="filename"
        :pending="pending"
        @close="closeStatusDialog"
      >
      </status-info>
    </v-dialog>
    <!----------------------------------------------------------------------------->

    <!-----------------IF SERVER IS COMPLETELY DOWN--------------------------------->
    <status-info
      v-if="failed && filename !== ''"
      :responseMessage="responseMessage"
      :filename="filename"
      :pending="pending"
      @close="reset"
    >
    </status-info>
    <!------------------------------------------------------------------------------->

    <!-------------------RED SNACKBAR----------------------------------------------->
    <v-snackbar top v-model="snackbar" color="#FF3232" class="white--text">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <!------------------------------------------------------------------------------->
  </v-container>
</template>

<script>
import StatusInfo from "../organisms/StatusInfo";
import axios from "axios";
export default {
  name: "WHCategories",
  components: {
    StatusInfo,
  },
  data: () => ({
    selected: false,
    currentId: "",
    currentCategory: "",
    creatingNew: false,
    items: [],
    tab: "",
    active: [],
    forUse: false,
    titleNew: "",
    SKU_Code: "",
    dialogCreate: false,
    fields: [],
    dialogText: "",
    headers: [
      { text: "Name", value: "name" },
      { text: "Type", value: "fieldType" },
      { text: "Required", value: "required" },
      { text: "Purpose", value: "purpose" },
    ],
    fieldTypes: [
      { text: "Select", value: "select" },
      { text: "Text", value: "string" },
    ],
    purposes: ["Measurements", "Size", "Composition", "Other"],
    tabs: [
      { value: "config", text: "Configuration" },
      { value: "edit_conf", text: "Edit configuration" },
    ],
    rules: {
      required: (value) => !!value || "Field is required.",
      requiredMultiple: (value) => value.length > 0 || "Field is required",
    },
    responseMessage: "",
    filename: "",
    failed: false,
    search: null,
    caseSensitive: false,
    configSuccess: true,
    statusDialog: false,
    image: "",
    snackbar: false,
    snackbarText: "",
    valid: false,
    expanded: false,
    newCategory: {},
    pending: false,
    selectedConfiguration: [],
    languages: [],
    openSKUCODE: false,
    WithoutSKUs: [],
  }),
  computed: {
    filter() {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined;
    },
  },
  watch: {
    forUse(val) {
      if (val == null) this.forUse = false;
    },
  },
  methods: {
    async AddSkus() {
      this.pending = true;
      this.statusDialog = true;
      await axios
        .post("/api/WHCategories/missingSKU", this.WithoutSKUs)
        .then(() => {
          this.openSKUCODE = true;
          this.pending = false;
          this.statusDialog = false;
          this.filename = "high_five.svg";
          this.statusDialog = true;
          this.responseMessage = "Categories updated successfully !";
          this.fetchCategories();
          this.$refs.createForm.reset();
        });
    },
    closeAddSKU() {
      this.openSKUCODE = false;
    },
    async AddSKUCode() {
      this.pending = true;
      this.statusDialog = true;
      await axios.get("/api/WHCategories/fetchMissingSKU").then((res) => {
        this.WithoutSKUs = res.data;
        this.openSKUCODE = true;
        this.pending = false;
        this.statusDialog = false;
      });
    },
    toggleTreeview() {
      this.expanded = !this.expanded;
      this.$refs.mytreeview.updateAll(this.expanded);
    },
    async getLanguages() {
      this.$store.dispatch("getWHLanguage").then((res) => {
        this.languages = res.data;
      });
    },
    closeStatusDialog() {
      this.statusDialog = false;
    },
    setCategoryDetails() {
      // TODO add the category selected details in the right div
      if (this.active[0].configuration) {
        this.selectedConfiguration = this.active[0].configuration;
      } else {
        this.active[0].configuration = [
          { title: null, type: null, values: null },
        ];
        this.selectedConfiguration = [
          { title: null, type: null, values: null },
        ];
      }
    },
    addField() {
      this.selectedConfiguration.push({
        title: null,
        type: null,
        values: null,
      });
    },
    removeField(index) {
      this.selectedConfiguration.splice(index, 1);
    },
    // getting categories from server
    fetchCategories() {
      this.$store
        .dispatch("fetcWHCategories")
        .then((response) => {
          this.items = response.data;
        })
        .catch((error) => {
          this.textColor = "red--text";
          this.pending = false;
          this.responseMessage = error.response.data;
          console.log(JSON.stringify(error.response.status));
          if (error.response) {
            this.showErrors(error?.response?.status, error.response.data);
          } else {
            // anything else
            this.filename = "feeling_blue.png";
            this.responseMessage =
              "SORRY... Couldn't get categories. Something went wrong.";
          }
        });
    },

    reset() {
      this.$router.go();
    },
    closeCreateDialog() {
      this.dialogCreate = false;
      this.$refs.createForm.reset();
    },
    //opens create dialog when clicked 'Add new top level category' button at the bottom
    openCreateTopCategory() {
      this.creatingNew = true;
      this.dialogText = "Create new top level category";
      this.dialogCreate = true;
    },
    //opens create dialog when clicked + button near category
    openCreateSubCategory(item) {
      this.dialogCreate = true;
      this.dialogText = "Create new sub-category for " + item.name;
      this.currentId = item.id;
      this.currentCategory = item.name;
    },
    pushConfig() {
      var data = {
        ...this.active[0],
        configuration: this.selectedConfiguration,
      };
      this.statusDialog = true;
      this.pending = true;
      this.$store.dispatch("updateWHCategory", data).then((result) => {
        console.log(result);
        this.fetchCategories();
        this.$refs.createForm.reset();
        this.filename = "high_five.svg";
        this.pending = false;

        this.responseMessage = "Category has been updated !";
      });
    },
    //creates new category/sub-category
    createCategory() {
      if (this.$refs.createForm.validate()) {
        //check if we are creating top level category
        if (this.creatingNew) {
          this.postNewRootCategory();
        } else {
          this.postNewSubCategory();
        }
      }
    },
    postNewSubCategory() {
      //create child category
      let data = {
        ...this.newCategory,
        ParentId: this.currentId,
      };
      this.pending = true;
      this.dialogCreate = false;
      this.creatingNew = false;
      this.statusDialog = true;

      this.$store
        .dispatch("createWHCategory", data)
        .then(() => {
          this.dialogCreate = false;
          this.creatingNew = false;
          this.filename = "high_five.svg";
          this.statusDialog = true;
          this.responseMessage =
            "Success! Sub-category " +
            this.newCategory.titleNew +
            " created for category " +
            this.currentCategory;
          this.fetchCategories();
          this.$refs.createForm.reset();
          this.pending = false
        })
        .catch((error) => {
          this.textColor = "red--text";
          this.pending = false;
          this.responseMessage = error.response.data;
          if (error.response) {
            this.showErrors(error.response.status, error.response.data);
          } else {
            // anything else
            this.filename = "feeling_blue.png";
            this.responseMessage =
              "SORRY... Couldn't get category config. Something went wrong.";
          }
        });
    },
    postNewRootCategory() {
      //create whole new category
      this.pending = true;
      this.dialogCreate = false;
      this.creatingNew = false;
      this.statusDialog = true;
      this.$store
        .dispatch("createWHCategory", this.newCategory)
        .then(() => {
          this.dialogCreate = false;
          this.creatingNew = false;
          this.pending = false
          this.filename = "high_five.svg";
          this.statusDialog = true;
          this.responseMessage =
            "Success! Category " + this.newCategory.titleNew + " created!";
          this.fetchCategories();
          this.$refs.createForm.reset();
        })
        .catch((error) => {
          this.responseMessage = error.response?.data;
          this.filename = "server_down.svg";
          this.statusDialog = true;
          this.pending = false
          this.$refs.createForm.reset();
        });
    },

    showErrors(status, message) {
      // client received an error response (5xx, 4xx)
      this.responseMessage = message;
      switch (status) {
        case 400:
          this.filename = "empty.svg";
          break;
        case 401:
          //clear local storage, push to login
          localStorage.clear();
          this.$router.push("login");
          break;
        case 403:
          this.filename = "403_forbidden.svg";
          break;
        case 404:
          this.responseMessage = "Bad request. Please contact TECH team.";
          this.filename = "void.png";
          break;
        case 500:
          this.filename = "server_down.svg";
          break;
        default:
          this.responseMessage = "Bad request. Please contact TECH team.";
          this.filename = "void.png";
      }
    },
  },
  created() {
    this.fetchCategories();
    this.getLanguages();
  },
};
</script>

<style>
#addBtn:hover {
  transform: scale(1.15);
}
.container_sku_code {
  padding: 2em 1.5em;
  border-bottom: 2px solid lightgray;
  background-color: #f2f9ff;
  margin: 1em 0;
}
</style>
